module.exports = __webpack_public_path__ + "static/media/2.0655aa8c.png";